(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GptSettings',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// nothing for now
	};
}(jQuery, window.Adzuki || {}));
